import React from "react"

export default () => (
  <svg viewBox="0 0 32 32" width="100%" height="100%" className="fill-current">
    <title>Github</title>
    <path d="M16,0C7.2,0,0,7.2,0,16c0,7.1,4.6,13.1,10.9,15.2c0.8,0.1,1.1-0.3,1.1-0.8c0-0.4,0-1.6,0-3 c-4,0.7-5.1-1-5.4-1.9c-0.2-0.5-1-1.9-1.6-2.3c-0.6-0.3-1.4-1,0-1.1c1.3,0,2.2,1.2,2.5,1.6c1.4,2.4,3.7,1.7,4.7,1.3 c0.1-1,0.6-1.7,1-2.1c-3.6-0.4-7.3-1.8-7.3-7.9c0-1.7,0.6-3.2,1.6-4.3c-0.2-0.4-0.7-2,0.2-4.2c0,0,1.3-0.4,4.4,1.6 c1.3-0.4,2.6-0.5,4-0.5c1.4,0,2.7,0.2,4,0.5c3.1-2.1,4.4-1.6,4.4-1.6c0.9,2.2,0.3,3.8,0.2,4.2c1,1.1,1.6,2.5,1.6,4.3 c0,6.1-3.7,7.5-7.3,7.9c0.6,0.5,1.1,1.5,1.1,3c0,2.1,0,3.9,0,4.4c0,0.4,0.3,0.9,1.1,0.8C27.4,29.1,32,23.1,32,16C32,7.2,24.9,0,16,0 z"></path>
  </svg>
)
